import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Creates an order, opens Razorpay checkout, verifies on success.
// payload: { type: 'opd'|'checkup', item_id, coverage_type? }
// Returns the verify response on success, or null on cancel/failure.
export async function startPayment(payload) {
  const ok = await loadRazorpayScript();
  if (!ok) {
    toast.error("Couldn't load the payment gateway. Check your connection and retry.");
    return null;
  }
  let order;
  try {
    const { data } = await api.post("/payments/create-order", payload);
    order = data;
  } catch (err) {
    toast.error(formatApiErrorDetail(err.response?.data?.detail));
    return null;
  }

  return new Promise((resolve) => {
    const options = {
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: order.name,
      description: order.description,
      order_id: order.order_id,
      prefill: order.prefill,
      theme: { color: "#065F46" },
      handler: async (res) => {
        try {
          const { data } = await api.post("/payments/verify", {
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
          });
          toast.success("Payment successful!");
          resolve(data);
        } catch (err) {
          toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Payment verification failed");
          resolve(null);
        }
      },
      modal: { ondismiss: () => resolve(null) },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () => {
      toast.error("Payment failed. Please try again.");
      resolve(null);
    });
    rzp.open();
  });
}
